import { useEffect, useState } from 'react'

export const useInitUtmColizeum = () => {
  const [isColizeum, setIsColizeum] = useState(false)

  useEffect(() => {
    if (window.location.search.includes('utm_source=colizeum')) {
      setIsColizeum(true)
      sessionStorage.setItem('isColizeum', 'true')
    } else {
      const isColizeumFromStorage = sessionStorage.getItem('isColizeum')

      if (isColizeumFromStorage) {
        setIsColizeum(isColizeumFromStorage === 'true')
      }
    }
  }, [])

  return { isColizeum, setIsColizeum }
}
